import React from "react";
import "../Assets/Styles.css";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Developer from "../Assets/HomeImage.svg";

function Home() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <div>
        <Typography variant="h2" component="h2" gutterBottom className="Header">
          WELCOME!!
        </Typography>
        <Divider />
      </div>
      <div
        style={{
          maxHeight: "75%",
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          margin: "auto",
          width: "90%",
          justifyContent:'space-around',marginBottom:'20px'
        }}
      >
        <div style={{ width: "400px", maxWidth: "100vw",verticalAlign:'middle' }}>
          <Typography
            variant="h3"
            component="h3"
            gutterBottom
            className="shadow"
            color="secondary"
          >
            Bringing the WEB to your hands :)
          </Typography>
        </div>

        <div style={{ maxWidth: "500px", width: "60%" }}>
          <img src={Developer} />
          <div style={{width:'100%',textAlign:'right',fontSize:10}}>
          <a href="https://www.freepik.com/vectors/website" style={{textDecoration:'none',color:'gray'}}>
            Website vector created by stories
          </a>
          </div>
        </div>
      </div>
      <div style={{ marginRight: "50px" }}>
        <Typography
          variant="overline"
          display="block"
          gutterBottom
          className="Overline"
        >
          “Life is and will ever remain an equation incapable of solution, but
          it contains certain known factors.” - Nikola Tesla
        </Typography>
      </div>
    </div>
  );
}

export default Home;
